// Import Packages
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState, useRecoilValue } from 'recoil';

// Import Material UI Elements
import Button from '@material-ui/core/Button';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

// Import Recoil
import { alertState, baseOrigin, lastFocusField } from '../../../../../recoil-store/recoil-state';

// Import Icons
import CloseIcon from '../../../../../assets/icons/close-icon.svg';
import SettingsIcon from '../../../../../assets/icons/SettingsIcon';
import BluePlusIcon from '../../../../../assets/icons/blue-plus-icon';
import DeleteIcon from '../../../../../assets/icons/trash-box'

// Import Services
import LibraryService from '../../../../../services/LibraryService/LibraryService';
import ActionService from '../../../../../services/ActionService/ActionService';

// Import Libraries
import { libraries } from './Libraries';

// Import Pages
import ConfigurationForm from '../../../index'
import { Checkboxes } from '../../../../FlowConfigurationInputs';
import Condition from '../Condition/Condition';
import DeleteConfirm from "../../../../../components/DataTable/DeleteConfirm";
import Info from "../../../../../home/pages/automs/autom/editAction/components/Info";

// Import Helpers
import { getVariableIcon } from "../../../../../helpers/helper";

const useStyles = makeStyles(theme => ({
    option: {
        '& > span': {
            marginRight: 10,
            fontSize: 12,
        },
        fontSize: 13,
        fontWeight: 600,
        color: '#46474E',
    },
    inputRoot: {
        "& fieldset": {
            borderColor: '#E6E6E6',
            borderWidth: '1.1px'
        }
    },
    popupIndicator: {
        color: "#B0B0B0",
        height: "10px",
        width: "10px"
    }
}));

function TransformArea({ baseAction, manipulation, setManipulations, data, index, variables,
    setOpenVariable, variableRender, addNewAction, deleteAction, automDetail }) {


    const [expand, setExpand] = useState(false);
    const [actions, setActions] = useState([]);
    const [selectedAction, setSelectedAction] = useState({});
    const [showConfirm, setShowConfirm] = useState({ show: false, indexToRemove: -1 });



    const [imagePath, setImagePath] = useState("");
    const [libraryName, setLibraryName] = useState("");
    const [hasCondition, setHasCondition] = useState(false);
    const [conditions, setConditions] = useState([]);
    const base_origin = useRecoilValue(baseOrigin);
    const setFocusField = useSetRecoilState(lastFocusField);

    const classes = useStyles();

    const label = "CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.DATA-TRANSFORM.";
    const { t } = useTranslation();

    useEffect(() => {
        const fetch = async () => {

            if (data.type) {
                let library_name = data.type.replace(" ", "-");
                library_name = library_name.toUpperCase();
                setLibraryName(library_name);
                if (libraries[library_name]) {
                    const result = await LibraryService.getLibraryImagePath(library_name);
                    if (result && result.code === 200) {
                        let imgPath = base_origin + "/libraries/system/" + result.data.image;
                        setImagePath(imgPath);
                    }
                    let a = JSON.parse(JSON.stringify(libraries[library_name]));
                    if (manipulation?.action?.name) {
                        let s = a.find(x => x.name === manipulation.action.name)
                        if (s) {
                            setSelectedAction(s);
                        } else {
                            // hata var...
                        }
                        setHasCondition(manipulation.hasCondition ? true : false);
                    } else {
                        setSelectedAction({});
                        setHasCondition(false);
                    }

                    setActions(a);
                }
            }

        }
        fetch();
    }, [manipulation])

    const changeAction = async (v) => {
        if (v) {
            let ac = JSON.parse(JSON.stringify(v));
            if (ac.name !== "NO-ACTION") {
                const result = await ActionService.getActionShortDetail(libraryName, v.name);
                if (result && result.code === 200) {
                    ac.id = result.data.id;
                    ac.libraryVersion = result.data.library_version.version;
                }
            }

            ac.libraryName = libraryName;
            ac.actionName = v.name;
            ac.isDebugging = false;
            ac.definition = libraryName + "_" + v.name;

            Object.keys(ac.fields).forEach((key) => {
                if (ac.fields[key].defaultValue) {
                    ac.fields[key].value = ac.fields[key].value.replace('-', "sys_data_transform_variable");
                }
            })

            setManipulations(prev => {
                let m = [...prev];

                m[index].action = ac;

                return m;
            });

        } else {
            v = {};
            setManipulations(prev => {
                let m = [...prev];

                m[index].action = {};

                return m;
            });
        }
        setSelectedAction(v);
    }

    const setField = (inputName, value) => {
        // let actionData = [...actions];
        // if (hasCondition && actionData[index].children) {
        //     actionData[index].children[0].children[0].fields[inputName] = value;
        // } else {
        //     actionData[index].fields[inputName] = value;
        // }

        setManipulations(prev => {
            let m = [...prev];
            m[index].action.fields[inputName] = value;
            //m[index] = { ...m[index], action: { ...m[index].action, } };

            return m;
        });
        // setActions(actionData)
    }

    // const changeHasCondition = (checked) => {
    //     setHasCondition(!hasCondition)
    //     let actionData = [...actions];
    //     if (checked) {
    //         let c = []
    //         if (conditions.length < 1) {
    //             c = addCondition(true);
    //         } else {
    //             c = [...conditions];
    //         }
    //         let condition = {
    //             "flow": "rowCol",
    //             "name": "CONDITION",
    //             "type": "condition",
    //             "children": [
    //                 {
    //                     "name": "IF",
    //                     "type": "groupable",
    //                     "fields": { conditions: { type: "CONDITION", value: c } },
    //                     "children": [],
    //                     "actionName": "IF",
    //                     "action_name": "IF",
    //                     "isDebugging": false,
    //                     "libraryName": "CONDITION",
    //                     "action_label": "IF",
    //                     "libraryLabel": "CONDITION",
    //                     "library_name": "CONDITION",
    //                     "library_label": "CONDITION",
    //                     "conditionGroupId": "8b26a530-6e34-4b96-b506-3e40d44f99f9"
    //                 }
    //             ],
    //             "action_name": "CONDITION",
    //             "flow_behavior": [
    //                 "vertical",
    //                 "groupable"
    //             ]
    //         }
    //         if (actionData[index].name && actionData[index].name !== 'CONDITION') {
    //             condition.children[0].children.push(actionData[index]);
    //         }
    //         actionData[index] = condition;
    //         setActions(actionData);

    //     } else {
    //         if (actionData[index].name) {
    //             if (actionData[index].name === 'CONDITION') {
    //                 if (actionData[index].children[0].children.length > 0) {
    //                     actionData[index] = actionData[index].children[0].children[0]
    //                 } else {
    //                     actionData[index] = {};
    //                 }
    //                 setActions(actionData);
    //             }
    //         }
    //     }
    // }

    const addCondition = (fromChangeHasCondition) => {
        let c = manipulation.conditions ? [...manipulation.conditions] : [];
        if (c.length) {
            c[c.length - 1].logic = 'and';
        }
        const newCondition = {
            logic: "last",
            fields: {
                firstValue: {
                    value: ''
                },
                secondValue: {
                    value: ''
                },
                caseSensitive: {
                    value: false
                }
            },
            operator: "",
            condition: "",
            firstBool: true,
            secondBool: true
        }
        c.push(newCondition);


        setManipulations(prev => {
            let m = [...prev];

            m[index].hasCondition = true;
            m[index].conditions = c;
            return m;
        });

    }

    const conditionOnChange = ({ value }) => {
        if (value) {
            addCondition(true);
            setHasCondition(value);
        } else {
            setManipulations(prev => {
                let m = [...prev];

                m[index].hasCondition = value;
                m[index].conditions = [];
                return m;
            });
            setHasCondition(value);
        }

    }

    const removeCondition = () => {
        let c = [...manipulation.conditions];
        c.splice(showConfirm.indexToRemove, 1);
        c[c.length - 1].logic = 'last'
        setManipulations(prev => {
            let m = [...prev];
            m[index].conditions = c;
            return m;
        });
        setFocusField({
            inputName: '',
            type: '',
            is_sys_field: false
        })
    }

    const resetConditionConfiguration = () => {
        let c = [...manipulation.conditions];
        c[showConfirm.indexToRemove] = {
            logic: "last",
            fields: {
                firstValue: {
                    value: ''
                },
                secondValue: {
                    value: ''
                },
                caseSensitive: {
                    value: false
                }
            },
            operator: "",
            condition: "",
            firstBool: true,
            secondBool: true
        }

        setManipulations(prev => {
            let m = [...prev];
            m[index].conditions = c;
            return m;
        });

        setFocusField({
            inputName: '',
            type: '',
            is_sys_field: false
        })
    }

    const showRemoveConfirm = (indexToRemove) => {
        setShowConfirm({ show: true, indexToRemove: indexToRemove });
    }

    return (
        <div className={`manipulation-area ${!expand ? 'min-h-116' : ""}`}>
            <div className='transform-header-container'>
                <div className='items-center position-r m-l-16'>
                    {data.type && getVariableIcon(data.type, "", "#FFFFFF")}
                    <Info value={data.assignType === "different" && data.diffrentPaths ?
                        data.diffrentPaths.join(", ").replaceAll("#", "") :
                        data.path
                    } placement="top" delay={1000}>
                        <div className='transform-data-path'>
                            {data.assignType === "different" && data.diffrentPaths ?
                                data.diffrentPaths.join(", ").replaceAll("#", "") :
                                data.path
                            }
                        </div>
                    </Info>

                </div>
                <div className='items-center'>

                    <DeleteIcon onClick={() => deleteAction(index)} fill="#FFFFFF" width={12} height={12} className="icon-cursor-pointer" />
                    {expand ? <KeyboardArrowDown className="transform-area-arrow" onClick={() => setExpand(false)} /> :
                        <KeyboardArrowUp className="transform-area-arrow" onClick={() => setExpand(true)} />}
                </div>
            </div>

            {
                !expand &&
                <div className='transform-area-content'>
                    <div className='items-center'>
                        <div className='manipulate-counter-container'>
                            <div class="manipulate-counter-text m-b-1">{index + 1}</div>
                        </div>
                        <Autocomplete
                            value={selectedAction}
                            onChange={(e, newValue) => changeAction(newValue)}
                            id={`data-transform-action-list-${index}`}
                            style={{ width: 253, position: 'relative', background: '#FBFBFB' }}
                            size="small"
                            options={actions}
                            classes={{
                                option: classes.option,
                                inputRoot: classes.inputRoot,
                                popupIndicator: classes.popupIndicator
                            }}
                            autoHighlight
                            getOptionLabel={(option) => option.name ? (option.name === "NO-ACTION" ? t(label + "NO-ACTION") : t(`CONTENT.LIBRARY.${libraryName}.ACTION.${option.name}`)) : ""}
                            renderOption={(option) => (
                                <>
                                    {
                                        imagePath && <img loading="lazy" width="20" src={imagePath} alt="" style={{ marginRight: '10px' }} />
                                    }
                                    {option.name === "NO-ACTION" ? t(label + "NO-ACTION") : t(`CONTENT.LIBRARY.${libraryName}.ACTION.${option.name}`)}
                                </>
                            )}
                            renderInput={(params) => (
                                <>
                                    {
                                        imagePath &&
                                        <img className='input-action-icon' src={imagePath} />
                                    }
                                    <TextField
                                        {...params}
                                        id='select-action-list-text'
                                        className="select-action-input"
                                        placeholder="Select Action"
                                        variant="outlined"
                                        classes={{
                                            root: classes.inputRoot
                                        }}
                                        inputProps={{
                                            ...params.inputProps,
                                            "aria-autocomplete": 'new-password',
                                            autoComplete: 'new-password', // disable autocomplete and autofill
                                            style: {
                                                marginLeft: '36px',
                                                fontSize: 12,
                                                fontWeight: 600,
                                                color: '#46474E'
                                            }
                                        }}
                                    />
                                </>
                            )}
                        />
                        <div className='add-transform-action' onClick={addNewAction}>
                            <BluePlusIcon fill={"#FFFFFF"} className='add-transform-icon' />
                        </div>
                    </div>

                    <div className='transform-configuration-form-container'>

                        {
                            manipulation?.action?.libraryName && manipulation?.action.name !== "NO-ACTION" && (
                                <ConfigurationForm automDetail={automDetail} visible={true} setField={setField} selectedAction={manipulation.action}
                                    variables={variables} automId={automDetail.id} automVersionId={automDetail.versionId}
                                    setOpenVariable={setOpenVariable} variableRender={variableRender} fromFlow={false} />
                            )
                        }
                        <div className="t-a-condition-container">
                            <Checkboxes action={hasCondition} options={{ label: label + "CONDITION-QUESTION" }}
                                style={{ fontSize: '10px', fontWeight: '600', lineHeight: '13.66px', color: "#162436" }}
                                checkboxStyle={{ transform: "scale(0.8)", color: `${hasCondition ? "#43AA41" : "#A4A4A4"}` }}
                                onChange={conditionOnChange} confirmMessage={t(label + "RESET-CONDITION-CONFIRM-MESSAGE")} />
                            <div className='add-condition-icon-container' onClick={addCondition}>
                                <BluePlusIcon fill={"#FFFFFF"} className='add-condition-icon' />
                            </div>
                        </div>

                        {
                            manipulation.conditions && manipulation.conditions.map((conditionInfo, conditionIndex) => (
                                <Condition conditionInfo={conditionInfo} index={index} conditionIndex={conditionIndex}
                                    removeCondition={showRemoveConfirm} variables={variables}
                                    setOpenVariable={setOpenVariable} setConditions={setConditions} setManipulations={setManipulations} />
                            ))
                        }

                        {
                            showConfirm?.show &&
                            <DeleteConfirm setOpenDelete={setShowConfirm}
                                message={t(label + (manipulation.conditions.length === 1 ? "RESET-CONDITION-QUESTION" : "DELETE-CONDITION-QUESTION"))}
                                deleteFunc={() => manipulation.conditions.length === 1 ? resetConditionConfiguration() : removeCondition()} />
                        }
                    </div>
                </div>


            }
        </div>
    )

}

export default TransformArea;